<template>
  <div class="container-input-filtros">
    <i class="fa fa-search icn-search"></i>
    <input
      :value="text"
      class="ipt-search"
      @input="$emit('update:text', $event.target.value)"
      @keydown="debounce(() => $emit('aplicarFiltro'), 1000, $event.key)()"
      type="text"
      :placeholder="filtro.placeholder"
    />
    <SettingAdvanced
      v-if="filtro.advanced"
      :campo="filtro"
      @update:advancedSetting="onUpdateAdvancedSetting"
    />
  </div>
</template>
<script>
import SettingAdvanced from './SettingAdvanced.vue';
export default {
  props: {
    filtro: {
      type: Object,
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    }
  },
  emits: ['aplicarFiltro', 'update:text'],
  components: {
    SettingAdvanced
  },
  data() {
    return {
      debounceTimeout: null
    };
  },
  methods: {
    debounce(func, wait, key) {
      return (...args) => {
        const regKey = /^[a-zA-Z0-9]$|Backspace/;
        if (!regKey.test(key)) return;

        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    },
    async onUpdateAdvancedSetting(value) {
      try {
        const filtros = await this.$filtroDb.recuperarFiltros(this.path);
        const filtroIndex = filtros.findIndex(f => f.filtro === this.filtro.filtro);
        if (filtroIndex !== -1) {
          filtros[filtroIndex].advancedSetting = value;
        } else {
          filtros.push({ ...this.filtro, advancedSetting: value });
        }
        await this.$filtroDb.salvarFiltros(this.path, filtros);
      } catch (error) {
        exibe_erro('Erro ao salvar preferência avançada de filtragem');
      }

      if (this.text.length > 0) {
        this.$emit('aplicarFiltro');
      }
    }
  },
}
</script>
